import { efAction } from '../constants.new';

export type DescriptorEntityType = 'company' | 'site' | 'parcel' | 'assessor' | 'collector';
export type DescriptorEntity = { entityId: number, entityTypeId: number, name: DescriptorEntityType };

export interface DescriptorOverrideDetail {
    canAssetUsageBeRemoved: boolean
    descriptorOverrideID: number;
    descriptorID: number;
    companyID: number;
    assetUsageID: number;
    efAction: efAction;
    parcelUsageID: number;
    siteUsageID: number;
    companyUsageId: number;
}

export interface DescriptorOverride {
    canAssetUsageBeRemoved?: boolean;
    categoryName: string;
    descriptorDTO: Core.DescriptorDTO;
    descriptorName: string;
    isHovered: boolean;
    descriptorOverride: DescriptorOverrideDetail;
}

export interface TypeaheadDescriptorDTO extends Core.DescriptorDTO {
    typeaheadField: string;
}

// Mirrors the seed values in dbo.DescriptorFormat. Controls how Number-type descriptor values
// are displayed/edited (thousands grouping and decimal precision).
export enum DescriptorFormats {
    NoSeparators = 1,
    CommaSeparators = 2,
    CommaSeparatorsDupe = 3,
    CommaSeparatorsPrecision2 = 4,
    CommaSeparatorsPrecision3 = 5
}

// Returns the number of decimal places a Number-type descriptor should be displayed/edited with,
// based on its DescriptorFormatId (see dbo.DescriptorFormat). Formats 1-3 are all whole-number
// formats (they only differ in whether thousands are comma-grouped), so they explicitly return 0
// rather than relying on the default case. Unmapped/null format IDs also default to 0 decimal places.
export function getDescriptorFormatDecimalPlaces(descriptorFormatId: number): number {
    switch (descriptorFormatId) {
        case DescriptorFormats.NoSeparators:
        case DescriptorFormats.CommaSeparators:
        case DescriptorFormats.CommaSeparatorsDupe:
            return 0;
        case DescriptorFormats.CommaSeparatorsPrecision2:
            return 2;
        case DescriptorFormats.CommaSeparatorsPrecision3:
            return 3;
        default:
            return 0;
    }
}

export interface EntityDescriptorModelUI extends Core.EntityDescriptorModel {
    isDeleted: boolean;
    value: any;
}
